module.exports = __webpack_public_path__ + "img/sw.51b1089e.png";